import { useState } from 'react';
import { Autocomplete, TextField, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { colors } from '@src/styles';

interface AutomationOption {
  key: string;
  type: 'CUSTOM' | 'CANONICAL';
}

export function AutomationSearch({
  items,
  onSelect,
}: {
  items: AutomationOption[];
  onSelect: (key: string, type: 'CUSTOM' | 'CANONICAL') => void;
}) {
  const [inputValue, setInputValue] = useState('');

  return (
    <Autocomplete
      options={items}
      value={null}
      inputValue={inputValue}
      onInputChange={(_e, newValue) => setInputValue(newValue)}
      onChange={(_e, option) => {
        if (option) onSelect(option.key, option.type);
      }}
      getOptionLabel={(option) => option.key}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.key}>
          {option.key}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Buscar automação"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <SearchIcon sx={{ fontSize: 17, color: `${colors.brand.textMuted} !important`, ml: 0.5 }} />
            ),
          }}
          sx={{
            minWidth: 240,
            '& .MuiOutlinedInput-root': {
              height: 36,
              paddingY: '0 !important',
              fontSize: '13px',
              backgroundColor: colors.background.primary,
              borderRadius: '8px',
              '& fieldset': { borderColor: colors.brand.line },
              '&:hover fieldset': { borderColor: 'rgba(255, 160, 21, 0.5)' },
              '&.Mui-focused fieldset': { borderColor: colors.primary.yellow, borderWidth: '1px' },
              '& input': { color: colors.primary.white },
              '& input::placeholder': { color: colors.brand.textMuted, opacity: 1 },
            },
            '& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator': {
              color: colors.brand.textSecondary,
              '& svg': { color: 'inherit' },
            },
          }}
        />
      )}
      slotProps={{
        paper: {
          sx: {
            marginTop: 0.5,
            backgroundColor: colors.brand.surface,
            backgroundImage: 'none',
            border: `1px solid ${colors.brand.line}`,
            borderRadius: '10px',
            boxShadow: '0 16px 40px rgba(0, 0, 0, 0.45)',
            color: colors.primary.white,
            '& .MuiAutocomplete-listbox': { padding: 0.5 },
            '& .MuiAutocomplete-option': {
              borderRadius: '6px',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '12px',
              '&.Mui-focused, &:hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)' },
              '&[aria-selected="true"]': { backgroundColor: 'rgba(255, 160, 21, 0.12) !important' },
            },
            '& .MuiAutocomplete-noOptions': { color: colors.brand.textSecondary, fontSize: '13px' },
          },
        },
      }}
      noOptionsText="Nenhuma automação encontrada"
    />
  );
}
